import { getRandomColor } from "../../utils/colorUtils";

const transformData = (etfData) => {
  let nodes = [], links = [];
  let nodeMap = new Map();
  let etfGroupMap = new Map(); // Map to store unique group numbers for ETFs
  const stockColor = "#aaaaaa"; // Common color for all stocks
  let currentGroup = 1; // Start group numbering for ETFs

  etfData.forEach(etf => {
    // Assign a unique group for each ETF based on incrementing currentGroup
    const etfColor = getRandomColor();
    etfGroupMap.set(etf.name, currentGroup);

    // Add ETF nodes with a unique group number and a larger node value for increased size
    nodes.push({ id: etf.name, group: currentGroup++, color: etfColor, val: 20 }); // Adjust nodeRelSize for visual distinction

    etf.children.forEach(stock => {
      // Ensure unique stock nodes with a common color and group
      if (!nodeMap.has(stock)) {
        nodes.push({ id: stock, group: 0, color: stockColor, val: 3 }); // Stocks share group 0
        nodeMap.set(stock, true);
      }
      // Link ETFs and stocks
      links.push({ source: etf.name, target: stock, value: 1, linkColor: '#AACCFF'  });
    });
  });

  return { nodes, links };
};

export const extractDataForForceChart = (positions) => {
  let data = [];
  for (let k in positions) {
    data.push({name: k, children: positions[k].holdings.map(x => x.symbol)});
  }
  return transformData(data);
}


export const extractUniqueEtfColors = (transformedData) => {
  if (!transformedData) {
    return [];
  }

  const etfColors = [];

  transformedData.forEach(node => {
    if (node.group !== 0) { // Assuming this is how you differentiate ETF nodes
      etfColors.push({ id: node.id, color: node.color });
    }
  });

  return etfColors;
};

export const findIntersectingPositions = (positions) => {
  const etfs = Object.keys(positions); // ETF names
  const etfSymbols = etfs.map(etf => positions[etf].holdings.map(holding => holding.symbol));
  const allSymbols = new Set(etfSymbols.flat());

  let symbolOwnership = {};

  allSymbols.forEach(symbol => {
    etfs.forEach(etf => {
      const ownsSymbol = positions[etf].holdings.some(holding => holding.symbol === symbol);
      if (ownsSymbol) {
        if (!symbolOwnership[symbol]) symbolOwnership[symbol] = {};
        symbolOwnership[symbol][etf] = true;
      }
    });
  });

  let intersectionData = {};

  Object.entries(symbolOwnership).forEach(([symbol, ownership]) => {
    const owningETFsCount = Object.keys(ownership).length;
    const key = owningETFsCount === etfs.length ? "all" : owningETFsCount;
    if (!intersectionData[key]) intersectionData[key] = { symbols: [], sortKey: owningETFsCount, ownership };
    intersectionData[key].symbols.push(symbol);
  });

  // Sort the intersection data by sortKey
  const sortedKeys = Object.keys(intersectionData).sort((a, b) => {
    // 'all' should always come first
    if (a === 'all') return -1;
    if (b === 'all') return 1;
    return intersectionData[b].sortKey - intersectionData[a].sortKey;
  });

  // Create a new sorted object with keys in the correct order
  const sortedIntersectionData = []
  sortedKeys.forEach(key => {
    sortedIntersectionData.push({
      key,
      symbols: intersectionData[key].symbols,
      ownership: Array.from(Object.keys(intersectionData[key].ownership))
    })
  });
  return sortedIntersectionData;
};

export const extractUniqueSectors = (positions) => {
    const sectors = new Set();
    Object.values(positions).forEach(etf => {
        etf.holdings.forEach(ticker => {
            sectors.add(ticker.sector);
        });
    });
    return Array.from(sectors);
};